import { coreApi } from '$api'
import {
  StaffMemberAuditRecord,
  transformStaffMemberAuditRecordsOnGet,
} from '$models'

/** React Query key for one staff member's audit records */
export const staffMemberAuditQueryKey = (staffMemberId: string) => [
  'staff-member-audit',
  staffMemberId,
]

/**
 * Every recorded change to a staff member, newest first
 * @param staffMemberId - staff member to get the history of
 * @returns Promise<StaffMemberAuditRecord[]>
 */
export const getStaffMemberAudit = async (
  staffMemberId: string
): Promise<StaffMemberAuditRecord[]> => {
  const records = await coreApi.getStaffMemberAudit(
    staffMemberId,
    undefined,
    undefined
  )

  return transformStaffMemberAuditRecordsOnGet(records)
}
